import React, { useState } from 'react';
import { Button, Flex, Form, Input } from "antd";
import { ReactComponent as LogoIcon } from '../../../../assets/images/logo/logo.svg'
import styles from './business-contact-us.module.scss'
import CustomButton from "../../../../components/UI/CustomButton/CustomButton";
import { ReactComponent as ArrowIcon } from '../../../../assets/images/global-icons/arrow_ic.svg'
import { useLocation, useNavigate } from "react-router";
import { useValidateCompanyByDomainMutation } from "../../../../redux/API/companySlice";
import { useDispatch } from "react-redux";
import { addSignUpData } from "../../../../redux/businessSlice"

const BusinessContactUs = () => {
  const [form] = Form.useForm();
  const [email, setEmail] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const placeId = location.state?.placeId;
  const companyName = location.state?.userCompanyName;
  const from = location.state?.from;
  const dispatch = useDispatch();
  const [validateCompany] = useValidateCompanyByDomainMutation();

  const handleContinueButton = async () => {
    try {
      const validateResponse = await validateCompany({ email }).unwrap();

      const { isEmailValid, isDomainExist } = validateResponse.data;

      if (isEmailValid && isDomainExist) {
        dispatch(addSignUpData({
          company: {
            companyName: from === 'companyName' ? email : companyName,
            email: from !== 'companyName' ? email : '',
            address: location.state?.address ?? '',
            placeId: placeId || '',
          }
        }));

        navigate('../business/email');
      } else {
        let errorMsg = 'Invalid email or domain';
        if (!isEmailValid) {
          errorMsg = 'Email is not valid';
        } else if (!isDomainExist) {
          errorMsg = 'Email domain does not exist';
        }

        form.setFields([
          {
            name: 'company',
            errors: [errorMsg],
          },
        ]);
      }
    } catch (error) {
      console.error(error);
      form.setFields([
        {
          name: 'company',
          errors: ['Server error. Please try again later.'],
        },
      ]);
    }
  };

  const handleClick = () => {
    const to = 'support@krankque.com';
    const subject = 'Request to Add My Company';
    const body = `Hello,\nI couldn't find my company ${from === 'companyName' ? email : companyName} in the list during registration. Could you please assist me with adding it? Let me know what steps I need to take.\nLooking forward to your response.`;

    const mailtoLink = `mailto:${to}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink;
  };

  return (
    <Flex className={styles.BusinessContactUs__wrapper} justify={"center"} align={"start"}>
      {
        from !== 'companyName' &&
        <ArrowIcon
          className={styles.BusinessContactUs__back}
          onClick={() => navigate('../business', { state: { placeId } })}
        />
      }
      <Flex className={styles.BusinessContactUs} vertical justify={'center'} align={"center"}>
        <Flex className={styles.BusinessContactUs__header} vertical justify={"center"} align={"center"} gap={'32px'}>
          <LogoIcon />
          <h1>{from === 'companyName' ? 'Enter your full company name' : 'Enter your email address'}</h1>
          <Flex className={styles.BusinessContactUs__header__subtitle} vertical>
            <p>
              {from === 'companyName' ?
                'Once your request is submitted, our team will get back to you as soon as possible'
                :
                'If your email is not listed, enter it manually and continue registration, or contact support for help'}

            </p>
          </Flex>
        </Flex>
        <Flex className={styles.BusinessContactUs__form__wrapper}>
          <Form
            form={form}
            className={styles.BusinessContactUs__form}
            layout="vertical"
          >
            <Form.Item
              name="company"
              rules={[
                {
                  required: true,
                  message: from === 'companyName' ? 'Company name is required' : 'Company email is required',
                },
              ]}
            >
              <Input
                placeholder={from === 'companyName' ? "Your company name" : "Your Email Address"}
                className={styles.BusinessContactUs__form__input}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Item>

            <Form.Item>
              <Flex gap={'12px'} vertical align={"center"} className={styles.BusinessContactUs__form__button}>
                {from !== 'companyName' ?
                  <>
                    <CustomButton
                      text={'Continue with this email'}
                      disable={!email}
                      onClick={handleContinueButton}
                    />
                    <Button className={styles.BusinessContactUs__form__button__link} onClick={handleClick} type={'link'}>
                      Contact support
                    </Button>
                  </>
                  :
                  <CustomButton
                    text={'Contact support'}
                    disable={!email}
                    onClick={handleClick}
                  />
                }

              </Flex>
            </Form.Item>
          </Form>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default BusinessContactUs;
